import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "adebd7e3-e1fd-423e-a7d6-42d75ff53e58",
    content: "Airborne - exhaust",
    options: { image: `${config.ASSETS_URL}/03/15/task/task-2-chart-1.svg` },
  },
  {
    id: "a950b9f0-afac-4d42-b89b-26246b78647c",
    content: "Airborne - engine comp",
    options: { image: `${config.ASSETS_URL}/03/15/task/task-2-chart-2.svg` },
  },
];

export const task: Task = {
  id: "fd0de168-32be-4c6d-98bd-59877d6c0738",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: false,
    imageHeight: 350,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["a950b9f0-afac-4d42-b89b-26246b78647c"],
};
